import Image from 'next/image';
import PropTypes from 'prop-types';
import MillesimaLink from '@/components/common/MillesimaLink';
import { BREAKPOINTS_LABELS } from '@/constants/gui';
import styles from './ImageCard.module.scss';

const ImageCard = ({ data, breakpoint }) => {
	const { icon, label, img, contentTitle, url, isNofollow, alt } = data;
	const relAttr = isNofollow ? { rel: 'nofollow' } : {};

	return (
		<div className={`${styles.card} ${styles[breakpoint] || ''}`} data-test-id="image-card">
			{label && (
				<div className={styles.header} data-test-id="image-card-header">
					{icon && (
						<div className={styles.icon} data-test-id="image-card-icon">
							<Image src={icon} alt="" width={24} height={21} loading="lazy" />
						</div>
					)}
					<div className={styles.label} data-test-id="image-card-label">
						{label}
					</div>
				</div>
			)}
			<div className={styles.img} data-test-id="image-card-img">
				<a href={url} aria-label={contentTitle || ''} {...relAttr}>
					<img src={img} alt={alt} loading="lazy" />
				</a>
			</div>
			{contentTitle && (
				<div className={styles.footer} data-test-id="image-card-footer">
					<MillesimaLink href={url} isNofollow isWithoutContainer>
						{contentTitle}
					</MillesimaLink>
				</div>
			)}
		</div>
	);
};

ImageCard.propTypes = {
	data: PropTypes.shape({
		icon: PropTypes.string,
		label: PropTypes.string,
		img: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired,
		contentTitle: PropTypes.string,
		isNofollow: PropTypes.bool,
		alt: PropTypes.string,
	}),
	breakpoint: PropTypes.oneOf(BREAKPOINTS_LABELS),
};

export default ImageCard;
